// Fila "Tabelas enviadas" do admin Everlog (PO1-2312, MeuFrete): a
// transportadora sobe a tabela de preço, a Everlog cadastra a FreteTabela
// (inativa) e liga o item; só o embarcador aprova.
import api from "./api";

const BASE = "/admin/tabelas-enviadas";

export async function listarTabelasEnviadas(params = {}) {
  const { data } = await api.get(BASE, { params });
  return data;
}

export async function detalheTabelaEnviada(id) {
  const { data } = await api.get(`${BASE}/${id}`);
  return data;
}

export async function urlArquivoTabelaEnviada(id, idArquivo) {
  const { data } = await api.get(`${BASE}/${id}/arquivos/${idArquivo}/url`);
  return data;
}

export async function tabelasCandidatas(id) {
  const { data } = await api.get(`${BASE}/${id}/tabelas-candidatas`);
  return data;
}

export async function iniciarTabelaEnviada(id) {
  const { data } = await api.post(`${BASE}/${id}/iniciar`);
  return data;
}

export async function vincularTabelaEnviada(id, { idFreteTabela }) {
  const { data } = await api.post(`${BASE}/${id}/vincular`, { idFreteTabela });
  return data;
}

export async function devolverTabelaEnviada(id, { motivo }) {
  const { data } = await api.post(`${BASE}/${id}/devolver`, { motivo });
  return data;
}

// Aprovação pelo embarcador (tela Tabelas de Frete).
export async function aprovarTabelaFrete(idFreteTabela) {
  const { data } = await api.post(`/frete/tabelas/${idFreteTabela}/aprovar`);
  return data;
}
